/* eslint-disable object-shorthand */

const authBase = '/auth';

export const authRoutes = {
	login: 'login',
	forgot: 'password/forgot',
	verifyForgot: 'password/verify-email',
	reset: 'password/reset',
	register: 'register',
};

const verifyProfile = '/profile/verify';
const completeProfile = '/profile/complete';
const dashboard = '/dashboard';
const notifications = '/dashboard/notifications';
const privacy = '/privacy/policy';
const term = '/term/condition';
const help = '/help';

const campaignBase = '/campaign';
export const campaignRoutes = {
	list: '',
	create: 'create',
	info: ':id',
	influence: 'influence',
};

export const accountBase = '/account';
export const accountSettingsRoutes = {
	registrationInformation: 'registration/information',
	paymentInformation: 'payment/information',

	changePlan: 'plan/update',

	passwordUpdate: 'password-update',

	branches: 'branches',
	branch: 'branches/:name',
	branchAdd: 'branches/addbranch',
	branchUpdate: 'branches/branch/update',
	branchDelete: 'branches/branch/delete',
};

export const routes = {
	authBase,
	authAny: `${authBase}/*`,
	login: `${authBase}/${authRoutes.login}`,
	forgot: `${authBase}/${authRoutes.forgot}`,
	verifyForgot: `${authBase}/${authRoutes.verifyForgot}`,
	reset: `${authBase}/${authRoutes.reset}`,
	register: `${authBase}/${authRoutes.register}`,
	verifyProfile,
	completeProfile,
	dashboard,
	help,
	privacy,
	term,
	notifications,
	campaign: {
		base: campaignBase,
		any: `${campaignBase}/*`,
		list: `${campaignBase}/${campaignRoutes.list}`,
		create: `${campaignBase}/${campaignRoutes.create}`,
		info: `${campaignBase}/${campaignRoutes.info}`,
		influence: `${campaignBase}/${campaignRoutes.influence}`,
	},
	accountSettingsRoutes: {
		base: accountBase,
		any: `${accountBase}/*`,
		registration: `${accountBase}/${accountSettingsRoutes.registrationInformation}`,

		paymentInformation: `${accountBase}/${accountSettingsRoutes.paymentInformation}`,

		plan: `${accountBase}/${accountSettingsRoutes.changePlan}`,

		branches: `${accountBase}/${accountSettingsRoutes.branches}`,
		branch: `${accountBase}/${accountSettingsRoutes.branch}`,
		branchAdd: `${accountBase}/${accountSettingsRoutes.branchAdd}`,
		branchUpdate: `${accountBase}/${accountSettingsRoutes.branchUpdate}`,
		branchDelete: `${accountBase}/${accountSettingsRoutes.branchDelete}`,

		passwordUpdate: `${accountBase}/${accountSettingsRoutes.passwordUpdate}`,
	},
};
